module.exports = __webpack_public_path__ + "img/12.93c53941.jpeg";